import { render, staticRenderFns } from "./DigikalaSellerShippingSettings.vue?vue&type=template&id=0d240618"
import script from "./DigikalaSellerShippingSettings.vue?vue&type=script&lang=js"
export * from "./DigikalaSellerShippingSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports